/* cl-pdp: comportamento do buybox copiado (Fabric + Globo Swatch do concorrente).
   O form da pagina e o do bloco nativo buy_buttons do Shrine; aqui escrevemos a variante
   escolhida nele, trocamos preco/selo/texto do ATC e levamos a galeria ate a foto da
   variante. O submit (botao com form=) e interceptado pela gaveta do carrinho. */
(function(){
  function each(r, s, fn){ [].forEach.call(r.querySelectorAll(s), fn); }
  function money(c, fmt){
    fmt = fmt || '{{amount}}';
    var n = c / 100;
    function grp(x, sep){ return x.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function(_, k){
      if (k === 'amount_no_decimals') return grp(Math.round(n).toString(), ',');
      if (k === 'amount_with_comma_separator') { var p = n.toFixed(2).split('.'); return grp(p[0], '.') + ',' + p[1]; }
      if (k === 'amount_no_decimals_with_comma_separator') return grp(Math.round(n).toString(), '.');
      if (k === 'amount_with_apostrophe_separator') { var q = n.toFixed(2).split('.'); return grp(q[0], "'") + '.' + q[1]; }
      var r = n.toFixed(2).split('.'); return grp(r[0], ',') + '.' + r[1];
    });
  }

  function initGallery(root){
    var g = root.querySelector('cl-media-gallery'); if (!g) return null;
    var sc = g.querySelector('cl-slideshow-slides');
    var slides = [].slice.call(g.querySelectorAll('[data-cl-media]'));
    var ctrls = [].slice.call(g.querySelectorAll('cl-slideshow-controls button[on\\:click^="/select/"]'));
    function mark(i){
      slides.forEach(function(s, k){ s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      ctrls.forEach(function(b){ b.setAttribute('aria-selected', +b.getAttribute('on:click').split('/').pop() === i ? 'true' : 'false'); });
    }
    function go(i){
      if (!slides[i]) return;
      mark(i);
      if (sc && sc.scrollWidth > sc.clientWidth + 2) sc.scrollTo({left: slides[i].offsetLeft - sc.offsetLeft, behavior: 'auto'});
    }
    ctrls.forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); go(+b.getAttribute('on:click').split('/').pop()); }); });
    if (sc) sc.addEventListener('scroll', function(){
      if (sc.scrollWidth <= sc.clientWidth + 2) return;
      var w = slides[0] ? slides[0].getBoundingClientRect().width : 1;
      mark(Math.round(sc.scrollLeft / (w || 1)));
    }, {passive: true});
    /* como o Horizon dele: a foto da variante vira a PRIMEIRA midia (slideshow do mobile,
       grade do desktop e miniaturas), o resto segue na ordem original */
    var grid = [].slice.call(g.querySelectorAll('[data-cl-media-grid]'));
    var thumbs = ctrls.filter(function(b){ return b.classList.contains('slideshow-controls__thumbnail'); });
    var ids = slides.map(function(s){ return s.getAttribute('data-cl-media'); });
    function reorder(list, order){
      if (list.length !== order.length || !list[0]) return;
      var par = list[0].parentNode;
      order.forEach(function(k){ par.appendChild(list[k]); });
    }
    var orig = {slides: slides.slice(), grid: grid.slice(), thumbs: thumbs.slice(), ids: ids.slice()};
    function toMedia(id){
      var i = orig.ids.indexOf(String(id)); if (i < 0) return;
      var order = [i].concat(orig.ids.map(function(_, k){ return k; }).filter(function(k){ return k !== i; }));
      reorder(orig.slides, order);
      reorder(orig.grid, order);
      reorder(orig.thumbs, order);
      slides = order.map(function(k){ return orig.slides[k]; });
      grid = order.map(function(k){ return orig.grid[k]; });
      thumbs = order.map(function(k){ return orig.thumbs[k]; });
      ids = order.map(function(k){ return orig.ids[k]; });
      thumbs.forEach(function(b, k){ b.setAttribute('on:click', '/select/' + k); });
      slides.forEach(function(s){ var im = s.querySelector('img[loading="lazy"]'); if (im) im.loading = 'eager'; });
      grid.slice(0, 2).forEach(function(s){ var im = s.querySelector('img[loading="lazy"]'); if (im) im.loading = 'eager'; });
      if (sc) sc.scrollLeft = 0;
      go(0);
    }
    return {toMedia: toMedia};
  }

  function initPdp(root){
    if (root.__cl) return; root.__cl = true;
    var data = {};
    try { data = JSON.parse(root.querySelector('script[data-cl-product]').textContent); } catch(e){}
    var variants = data.variants || [], fmt = data.money;
    var form = document.getElementById(root.getAttribute('data-form-id'));
    var gal = initGallery(root);
    var sel = [];
    var cur = variants.filter(function(v){ return v.available; })[0] || variants[0];
    var qs = new URLSearchParams(location.search).get('variant');
    if (qs) cur = variants.filter(function(v){ return String(v.id) === qs; })[0] || cur;
    if (cur) sel = cur.options.slice();
    function find(o){ return variants.filter(function(v){ return v.options.every(function(x, i){ return x === o[i]; }); })[0]; }

    function apply(push){
      var v = find(sel); if (!v) { v = cur; }
      cur = v;
      each(root, 'input[data-cl-opt]', function(r){
        var i = +r.getAttribute('data-cl-opt');
        r.checked = r.value === sel[i];
        var probe = sel.slice(); probe[i] = r.value; var pv = find(probe);
        var li = r.closest('li');
        if (li) { li.classList.toggle('available', !!(pv && pv.available)); li.classList.toggle('soldout', !(pv && pv.available)); }
      });
      each(root, '.swatch--gl', function(fs){
        var i = +fs.getAttribute('data-option-index'), n = fs.querySelector('.name-variant');
        if (n) n.innerHTML = '<span>: </span>' + (sel[i] || '');
      });
      var on = v.compare_at_price && v.compare_at_price > v.price;
      var pct = on ? Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
      each(root, '[data-cl-price]', function(e){ e.textContent = ' ' + money(v.price, fmt) + ' '; });
      each(root, '[data-cl-cmp]', function(e){ e.textContent = on ? ' ' + money(v.compare_at_price, fmt) + ' ' : ''; e.style.display = on ? '' : 'none'; });
      each(root, '[data-cl-pct]', function(e){ e.textContent = pct + '% OFF'; if (e.parentElement) e.parentElement.style.display = on ? '' : 'none'; });
      each(root, '[data-cl-atc]', function(b){
        b.disabled = !v.available;
        var t = b.querySelector('.add-to-cart-text__content');
        if (t) t.textContent = v.available ? ('Add to cart' + (on ? ' - Save ' + pct + '%' : '')) : 'Sold out';
      });
      if (form) {
        var inp = form.querySelector('input[name="id"], select[name="id"]');
        if (inp) { inp.value = v.id; inp.dispatchEvent(new Event('change', {bubbles: true})); }
      }
      if (push) {
        if (gal && v.featured_media) gal.toMedia(v.featured_media.id);
        if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); }
      }
    }
    each(root, 'input[data-cl-opt]', function(r){
      r.addEventListener('change', function(){ sel[+r.getAttribute('data-cl-opt')] = r.value; apply(true); });
    });
    apply(false);
    // link com ?variant=: abre na foto dela (o render do servidor sempre comeca pela 1a midia)
    if (qs && gal && cur && cur.featured_media) gal.toMedia(cur.featured_media.id);
  }

  function boot(){ document.querySelectorAll('[data-cl-pdp]').forEach(initPdp); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
